<template>
    <div>
        <h1 style="text-align: left; margin-top: unset">Invoice Detail</h1>
        <hr />
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/oms/invoice/InvoiceList' }"
                >InvoiceList</el-breadcrumb-item
            >
            <el-breadcrumb-item>รายการInvoice</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card shadow="never">
            <el-row :gutter="20">
                <el-col class="text-md-left" :span="12">
                    <el-button
                        type="warning"
                        icon="el-icon-message"
                        style="margin-right: 10px"
                        @click="confirmPickup()"
                        >Confirm Pickup</el-button
                    >
                </el-col>
                <el-col class="text-md-right" :span="12">
                    <el-button
                        type="danger"
                        icon="el-icon-info"
                        @click="showErrorDetail()"
                    ></el-button>
                    <el-button
                        type="info"
                        icon="el-icon-edit"
                        style="margin-right: 10px"
                        @click="addOrderNewInvoice()"
                        :disabled="invoiceForm.status === 1"
                        >เพิ่มออเดอร์</el-button
                    >
                    <el-dropdown v-if="showExport">
                        <el-button type="primary">
                            Export<i
                                class="el-icon-arrow-down el-icon--right"
                            ></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item @click.native="exportExcelAll"
                                ><fa-icon name="file-excel"></fa-icon
                                >&nbsp;ออเดอร์ทั้งหมด (Raw
                                Data)</el-dropdown-item
                            > -->
                            <el-dropdown-item @click.native="exportSummary"
                                ><fa-icon name="file-excel"></fa-icon
                                >&nbsp;Summary</el-dropdown-item
                            >
                            <el-dropdown-item @click.native="zipAllInvoice"
                                ><fa-icon name="file-archive"></fa-icon
                                >&nbsp;ออเดอร์ทั้งหมด และ PDF</el-dropdown-item
                            >
                        </el-dropdown-menu>
                    </el-dropdown>
                </el-col>
            </el-row>
            <br />
            <el-row>
                <el-col :span="24">
                    <table class="tbPaymentDetail" style="width: 100%">
                        <thead class="thead-dark">
                            <tr>
                                <th rowspan="2" width="220px"></th>
                                <th class="text-md-center" colspan="7">
                                    DEL (delivery)
                                </th>
                                <th class="text-md-center" colspan="10">COD</th>
                                <th class="text-md-center" colspan="2">
                                    Courier
                                </th>
                                <th
                                    class="text-md-center"
                                    colspan="3"
                                    v-if="showExport"
                                >
                                    จัดการ
                                </th>
                            </tr>
                            <tr>
                                <!-- DEL -->
                                <th class="text-md-center">
                                    Count of Order Excel
                                </th>
                                <th class="text-md-center">
                                    Count of Order DB
                                </th>
                                <th class="text-md-center">Sum of DEL Excel</th>
                                <th class="text-md-center">Sum of DEL DB</th>
                                <th class="text-md-center">WHT 1% (Excel)</th>
                                <th class="text-md-center">
                                    Inv.Total (Excel)
                                </th>
                                <th class="text-md-center">
                                    Customer Pay (Excel)
                                </th>
                                <!-- COD -->
                                <th class="text-md-center">
                                    Count of Order Excel
                                </th>
                                <th class="text-md-center">
                                    Count of Order DB
                                </th>
                                <th class="text-md-center">Sum of COD Excel</th>
                                <th class="text-md-center">Sum of COD DB</th>
                                <th class="text-md-center">
                                    COD Bef. VAT Excel
                                </th>
                                <th class="text-md-center">COD Bef. VAT DB</th>
                                <th class="text-md-center">VAT 7% (Excel)</th>
                                <th class="text-md-center">WHT 3% (Excel)</th>
                                <th class="text-md-center">
                                    Inv.Total (Excel)
                                </th>
                                <th class="text-md-center">
                                    Customer Pay (Excel)
                                </th>
                                <!-- Courier -->
                                <th class="text-md-center">Courier Excel</th>
                                <th class="text-md-center">Courier DB</th>
                                <!-- Other -->
                                <th
                                    class="text-md-center"
                                    width="100"
                                    v-if="showExport"
                                >
                                    ออเดอร์
                                </th>
                                <th
                                    class="text-md-center"
                                    width="100"
                                    v-if="showExport"
                                >
                                    นำข้อมูลออก
                                </th>
                                <th class="text-md-center" v-if="showExport">
                                    แก้ไข
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(obj, uerCode) in invoiceDetail">
                                <tr
                                    style="background-color: black; color: white"
                                    :key="uerCode"
                                >
                                    <td class="text-md-left">
                                        <b
                                            >{{ uerCode }}
                                            {{ getNameCustomer(obj).fname }}
                                            {{ getNameCustomer(obj).lname }}</b
                                        >
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).delCountExcel
                                        }}</b>
                                    </td>
                                    <td
                                        class="text-md-right"
                                        :style="{
                                            color:
                                                totalUserCode(obj)
                                                    .delCountExcel ===
                                                totalUserCode(obj).delCount
                                                    ? 'green'
                                                    : 'red'
                                        }"
                                    >
                                        <b>{{ totalUserCode(obj).delCount }}</b>
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).delExcel
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td
                                        class="text-md-right"
                                        :style="{
                                            color:
                                                totalUserCode(obj).delDb ===
                                                totalUserCode(obj).delExcel
                                                    ? 'green'
                                                    : 'red'
                                        }"
                                    >
                                        <b>{{
                                            totalUserCode(obj).delDb
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).delWht
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).delInvTotal
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).delCusPay
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <!-- COD -->
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).codCountExcel
                                        }}</b>
                                    </td>
                                    <td
                                        class="text-md-right"
                                        :style="{
                                            color:
                                                totalUserCode(obj).codCount ===
                                                totalUserCode(obj).codCountExcel
                                                    ? 'green'
                                                    : 'red'
                                        }"
                                    >
                                        <b>{{ totalUserCode(obj).codCount }}</b>
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).codExcel
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td
                                        class="text-md-right"
                                        :style="{
                                            color:
                                                totalUserCode(obj).codExcel ===
                                                totalUserCode(obj).codDb
                                                    ? 'green'
                                                    : 'red'
                                        }"
                                    >
                                        <b>{{
                                            totalUserCode(obj).codDb
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).codExclVatExcel
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td
                                        class="text-md-right"
                                        :style="{
                                            color:
                                                totalUserCode(obj)
                                                    .codExclVatExcel ===
                                                totalUserCode(obj).codExclVat
                                                    ? 'green'
                                                    : 'red'
                                        }"
                                    >
                                        <b>{{
                                            totalUserCode(obj).codExclVat
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).codVat
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).codWht
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).codInvTotal
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                    <td class="text-md-right">
                                        <b>{{
                                            totalUserCode(obj).codCusPay
                                                | currency("", ",", 2, ".")
                                        }}</b>
                                    </td>
                                </tr>
                                <template v-for="(obj2, accCode) in obj">
                                    <tr
                                        style="background-color: #80cbc4"
                                        class="bg-sencodary"
                                        :key="accCode"
                                    >
                                        <td class="text-md-center">
                                            <b>{{ accCode }}</b>
                                        </td>
                                        <!-- DEL -->
                                        <td class="text-md-right">
                                            <b>{{ obj2.delCountExcel }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{ obj2.delCount }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.delExcel
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.delDb
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.delWht
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.delInvTotal
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.delCusPay
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <!-- COD -->
                                        <td class="text-md-right">
                                            <b>{{ obj2.codCountExcel }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{ obj2.codCount }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.codExcel
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.codDb
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.codExclVatExcel
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.codExclVat
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.codVat
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.codWht
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.codInvTotal
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                        <td class="text-md-right">
                                            <b>{{
                                                obj2.codCusPay
                                                    | currency("", ",", 2, ".")
                                            }}</b>
                                        </td>
                                    </tr>
                                    <template
                                        v-for="(objInvoice,
                                        shopID) in obj2.invoiceDetail"
                                    >
                                        <tr
                                            style="background-color: #fff"
                                            class="bg-sencodary"
                                            :key="shopID + '-' + accCode"
                                        >
                                            <td class="text-md-right">
                                                <b
                                                    >INV{{
                                                        obj2.runningNumber
                                                    }}
                                                    {{ objInvoice.shopName }}</b
                                                >
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.delCountExcel
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{ objInvoice.delCount }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.delExcel
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.delDb
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.delWht
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.delInvTotal
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.delCusPay
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <!-- COD -->
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.codCountExcel
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{ objInvoice.codCount }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.codExcel
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.codDb
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.codExclVatExcel
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.codExclVat
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.codVat
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.codWht
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.codInvTotal
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.codCusPay
                                                        | currency(
                                                            "",
                                                            ",",
                                                            2,
                                                            "."
                                                        )
                                                }}</b>
                                            </td>
                                            <!-- Courier -->
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.courierNameExcel
                                                }}</b>
                                            </td>
                                            <td class="text-md-right">
                                                <b>{{
                                                    objInvoice.courierName
                                                }}</b>
                                            </td>
                                            <!-- Ma -->
                                            <td
                                                class="text-md-center"
                                                v-if="
                                                    showExport && shopID === 0
                                                "
                                                :rowspan="
                                                    obj2.invoiceDetail.length
                                                "
                                            >
                                                <el-button-group
                                                    v-if="
                                                        showAlert(
                                                            objInvoice.shopId
                                                        )
                                                    "
                                                >
                                                    <el-button
                                                        size="small"
                                                        @click="
                                                            showErrorDetailByShopId(
                                                                objInvoice.shopId
                                                            )
                                                        "
                                                        ><fa-icon
                                                            name="info-circle"
                                                        ></fa-icon
                                                    ></el-button>
                                                </el-button-group>
                                                <el-button-group>
                                                    <el-button
                                                        size="small"
                                                        @click="
                                                            showOrderList(
                                                                obj2.invoiceDetail
                                                            )
                                                        "
                                                        ><fa-icon
                                                            name="list"
                                                        ></fa-icon
                                                    ></el-button>
                                                </el-button-group>
                                            </td>
                                            <td
                                                class="text-md-center"
                                                v-if="
                                                    showExport && shopID === 0
                                                "
                                                :rowspan="
                                                    obj2.invoiceDetail.length
                                                "
                                            >
                                                <el-button-group>
                                                    <el-button
                                                        type="danger"
                                                        size="small"
                                                        @click="
                                                            exportPDF(
                                                                obj2,
                                                                obj2.runningNumber,
                                                                accCode
                                                            )
                                                        "
                                                        ><fa-icon
                                                            name="file-pdf"
                                                        ></fa-icon
                                                    ></el-button>
                                                    <!-- <el-button type="warning" size="small" @click="exportExcelNode(obj2.invoiceDetail,obj2.runningNumber,accCode)"><fa-icon name="file-excel"></fa-icon></el-button> -->
                                                </el-button-group>
                                                <el-button-group>
                                                    <el-button
                                                        type="success"
                                                        size="small"
                                                        @click="
                                                            exportExcel(
                                                                obj2.invoiceDetail,
                                                                obj2.runningNumber,
                                                                accCode
                                                            )
                                                        "
                                                        ><fa-icon
                                                            name="file-excel"
                                                        ></fa-icon
                                                    ></el-button>
                                                </el-button-group>
                                            </td>
                                            <td
                                                class="text-md-center"
                                                v-if="
                                                    showExport && shopID === 0
                                                "
                                                :rowspan="
                                                    obj2.invoiceDetail.length
                                                "
                                            >
                                                <el-button-group>
                                                    <el-button
                                                        size="small"
                                                        @click="
                                                            EditRunningNumber(
                                                                obj2.runningNumber,
                                                                obj2.invoiceDetail,
                                                                accCode
                                                            )
                                                        "
                                                        ><fa-icon
                                                            name="edit"
                                                        ></fa-icon
                                                    ></el-button>
                                                </el-button-group>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </template>
                            <tr class="">
                                <td style="border: unset"><b>Total</b></td>
                                <!-- DEL -->
                                <td class="text-md-right">
                                    <b>{{ invoiceTotal.delCountExcel }}</b>
                                </td>
                                <td
                                    class="text-md-right"
                                    :style="{
                                        color:
                                            invoiceTotal.delCountExcel ===
                                            invoiceTotal.delCount
                                                ? 'green'
                                                : 'red'
                                    }"
                                >
                                    <b>{{ invoiceTotal.delCount }}</b>
                                </td>
                                <td class="text-md-right">
                                    <b>{{
                                        invoiceTotal.delExcel
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td
                                    class="text-md-right"
                                    :style="{
                                        color:
                                            invoiceTotal.delExcel ===
                                            invoiceTotal.delDb
                                                ? 'green'
                                                : 'red'
                                    }"
                                >
                                    <b>{{
                                        invoiceTotal.delDb
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td class="text-md-right">
                                    <b>{{
                                        invoiceTotal.delWht
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td class="text-md-right">
                                    <b>{{
                                        invoiceTotal.delInvTotal
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td class="text-md-right">
                                    <b>{{
                                        invoiceTotal.delCusPay
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <!-- COD -->
                                <td class="text-md-right">
                                    <b>{{ invoiceTotal.codCountExcel }}</b>
                                </td>
                                <td
                                    class="text-md-right"
                                    :style="{
                                        color:
                                            invoiceTotal.codCountExcel ===
                                            invoiceTotal.codCount
                                                ? 'green'
                                                : 'red'
                                    }"
                                >
                                    <b>{{ invoiceTotal.codCount }}</b>
                                </td>
                                <td class="text-md-right">
                                    <b>{{
                                        invoiceTotal.codExcel
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td
                                    class="text-md-right"
                                    :style="{
                                        color:
                                            invoiceTotal.codExcel ===
                                            invoiceTotal.codDb
                                                ? 'green'
                                                : 'red'
                                    }"
                                >
                                    <b>{{
                                        invoiceTotal.codDb
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td class="text-md-right">
                                    <b>{{
                                        invoiceTotal.codExclVatExcel
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td
                                    class="text-md-right"
                                    :style="{
                                        color:
                                            invoiceTotal.codExclVatExcel ===
                                            invoiceTotal.codExclVat
                                                ? 'green'
                                                : 'red'
                                    }"
                                >
                                    <b>{{
                                        invoiceTotal.codExclVat
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td class="text-md-right">
                                    <b>{{
                                        invoiceTotal.codVat
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td class="text-md-right">
                                    <b>{{
                                        invoiceTotal.codWht
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td class="text-md-right">
                                    <b>{{
                                        invoiceTotal.codInvTotal
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                                <td class="text-md-right">
                                    <b>{{
                                        invoiceTotal.codCusPay
                                            | currency("", ",", 2, ".")
                                    }}</b>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </el-col>
            </el-row>
            <hr style="margin: 25px 0px" />
            <el-row>
                <el-col :span="12" class="text-md-left">
                    <el-form
                        ref="invoiceForm"
                        :rules="ruleInvoiceForm"
                        :model="invoiceForm"
                        label-width="220px"
                        label-position="left"
                        @submit="() => {}"
                    >
                        <el-form-item label="ชื่อรายการ" prop="name">
                            <el-input
                                v-model="invoiceForm.name"
                                :disabled="invoiceForm.status === 1"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="เลือกวันที่" prop="invoiceDate">
                            <el-date-picker
                                v-model="invoiceForm.invoiceDate"
                                type="date"
                                :editable="false"
                                format="yyyy/MM/dd"
                                value-format="yyyy/MM/dd"
                                placeholder="Pick a day"
                                :disabled="invoiceForm.status === 1"
                            >
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="หมายเหตุ" prop="note">
                            <el-input
                                type="textarea"
                                :rows="2"
                                v-model="invoiceForm.note"
                                :disabled="invoiceForm.status === 1"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button
                                type="primary"
                                @click="updateInvoice"
                                :disabled="invoiceForm.status === 1"
                                >บันทึก</el-button
                            >
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="4" :offset="8" class="text-md-right">
                    <el-button
                        type="primary"
                        @click="confirmInvoice()"
                        :disabled="invoiceForm.status === 1"
                        >Confirm Invoice</el-button
                    >
                </el-col>
            </el-row>
        </el-card>

        <add-order
            :dialogShow="dialogShowAddOrder"
            :listCourier="listCourier"
            @closeModalAddOrderInvoice="dialogShowAddOrder = false"
            @closeModalAddOrderInvoiceRefresh="fetchall"
        ></add-order>
        <detail-error
            :dialogShow="dialogShowDetailError"
            :listCourier="listCourier"
            :listError="listErrorNoShop"
            @closeModalDetailError="dialogShowDetailError = false"
            @closeModalDetailErrorRefresh="fetchall"
        ></detail-error>
        <order-list
            :dialogShow="orderlist.dialogShow"
            :shopId="orderlist.shopId"
            @closeModal="orderlist.dialogShow = false"
        ></order-list>
        <update-running-number
            :dialogShow="dialogShowRunningNumber"
            :runningNumber="runningNumberEdit"
            :shopId="shopIdRunningNumberEdit"
            :shopCode="shopCodeRunningNumber"
            @closeModalRunningNumber="dialogShowRunningNumber = false"
            @closeRefresh="fetchall"
        ></update-running-number>
        <ProgressBar />
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import AddOrder from '@/components/Invoice/DialogAddOrder'
import DetailError from '@/components/Invoice/DialogDetailError'
import OrderList from '@/components/Invoice/DialogOrderList'
import UpdateRunningNumber from '@/components/Invoice/DialogEditRunningNumber'
import mixinExcel from '@/mixins/exportExcel.js'
import jsZip from 'jszip'
import { saveAs } from 'file-saver'
import { call } from 'vuex-pathify'
import { eventBus } from '@/main'
import ProgressBar from '@/components/helper/ProgressBar.vue'
import pako from 'pako'
import { v4 as uuidv4 } from 'uuid'
const initInvoiceForm = {
    name: null,
    invoiceDate: null,
    note: null
}
export default {
    name: 'InvoiceUpload',
    mixins: [mixinExcel],
    components: {
        AddOrder,
        DetailError,
        OrderList,
        UpdateRunningNumber,
        ProgressBar
    },
    data () {
        return {
            dialogShowAddOrder: false,
            listCourier: [],
            dialogShowDetailError: false,
            listError: [],
            listErrorNoShop: [],
            invoiceForm: { ...initInvoiceForm },
            invoiceDetail: {},
            invoiceTotal: {},
            ruleInvoiceForm: {
                name: [
                    {
                        required: true,
                        message: 'กรุณากรอกชื่อรายการ',
                        trigger: 'blur'
                    }
                ],
                invoiceDate: [
                    {
                        required: true,
                        message: 'กรุณาเลือกวันที่จ่ายเงิน',
                        trigger: 'blur'
                    }
                ],
                note: [
                    {
                        required: true,
                        message: 'กรุณาระบุหมายเหตุ',
                        trigger: 'blur'
                    }
                ]
            },
            orderlist: {
                dialogShow: false,
                shopId: []
            },
            showExport: false,
            dialogShowRunningNumber: false,
            runningNumberEdit: '',
            shopIdRunningNumberEdit: [],
            AllShopIds: [],
            InvoiceRes: [],
            shopCodeRunningNumber: ''
        }
    },
    async created () {
        this.$loading()
        await this.fetchDetailError()
        await this.fetchInvoiceDetail()
        this.$nextTick(() => {
            // this.$loading().close()
        })
    },
    computed: {},
    methods: {
        ...call('invoice/*'),
        async exportExcelNode (shopID, runningNumber, shopCode) {
            this.$loading()
            let shopIds = shopID.map(e => e.shopId)
            var uniqShopIds = [...new Set(shopIds)]
            let param = {
                shop_ids: uniqShopIds,
                invoice_id: parseInt(this.$route.query.invoiceId)
            }
            try {
                let resOrderExport = await fgApi.invoice.getExportExcel(param)
                let paramExcel = {
                    detail: resOrderExport.data,
                    runningNumber: runningNumber,
                    shopCode: shopCode,
                    invoiceDate: this.invoiceForm.invoiceDate
                }
                let fileName = `-${shopCode}-INV${runningNumber}`
                await this.getExcelGenerate(paramExcel, fileName)
            } catch (e) {
                console.log(e)
                this.$message({
                    message: e,
                    type: 'error'
                })
            }
            this.$loading().close()
        },
        confirmPickup () {
            let paramList = []
            Object.values(this.invoiceDetail).forEach(e =>
                Object.values(e).forEach(s => {
                    let shopIds = s.invoiceDetail.map(e => e.shopId)
                    var uniqShopIds = [...new Set(shopIds)]
                    let param = {
                        shop_ids: uniqShopIds,
                        invoice_id: parseInt(this.$route.query.invoiceId),
                        shop_code: s.shopCode
                    }
                    paramList.push(param)
                })
            )

            this.$confirm(
                'ยืนยัน Confirm Pickup จำนวน: ' + paramList.length + ' รายการ',
                'Warning',
                {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }
            )
                .then(async () => {
                    this.$loading()
                    let listFail = []
                    let listPass = []
                    for await (let param of paramList) {
                        try {
                            let res = await fgApi.invoice.confirmPickup(param)
                            if (res.success) {
                                listPass.push({ param: param, res: res })
                            } else {
                                for (let i = 0; i < 3; i++) {
                                    let resAgain = await fgApi.invoice.confirmPickup(
                                        param
                                    )
                                    if (resAgain.success) {
                                        listPass.push({
                                            param: param,
                                            res: res
                                        })
                                        break
                                    } else {
                                        if (i === 2) {
                                            listFail.push({
                                                param: param,
                                                res: res
                                            })
                                        }
                                    }
                                }
                            }
                        } catch (error) {
                            console.log(error)
                        }
                    }
                    let fail = ''
                    if (listFail.length > 0) {
                        let shopCodeFail = listFail.map(e => e.param.shop_code)
                        fail = shopCodeFail.join()
                    }
                    let text = `รายการทั้งหมด ${paramList.length} <br>
                            รายที่สำเร็จ ${listPass.length} <br>
                            รายที่ไม่สำเร็จ ${listFail.length} <br>
                            ${fail}`
                    this.$alert(text, 'Result', {
                        confirmButtonText: 'OK',
                        dangerouslyUseHTMLString: true,
                        callback: action => {
                            // this.$message({
                            //     type: 'info',
                            //     message: `action: ${action}`
                            // })
                        }
                    })
                    this.$loading().close()
                })
                .catch(() => {
                    console.log('cancel')
                })
        },
        addOrderNewInvoice () {
            this.dialogShowAddOrder = !this.dialogShowAddOrder
            this.fetchListProvider()
        },
        showErrorDetail () {
            this.listErrorNoShop = this.listError.filter(e => {
                if (e.shopId === 0) {
                    return e
                }
            })
            this.dialogShowDetailError = !this.dialogShowDetailError
            this.fetchListProvider()
        },
        showErrorDetailByShopId (id) {
            this.listErrorNoShop = this.listError.filter(e => {
                if (e.shopId === id) {
                    return e
                }
            })
            this.dialogShowDetailError = !this.dialogShowDetailError
            this.fetchListProvider()
        },
        async fetchall () {
            await this.fetchDetailError()
            await this.fetchInvoiceDetail()
        },
        async fetchListProvider () {
            let res = await fgApi.courier.getListProvider()
            this.listCourier = res.data
        },
        async fetchDetailError () {
            let param = {
                invoice_id: parseInt(this.$route.query.invoiceId),
                limit: null,
                offset: null
            }
            try {
                let resError = await fgApi.invoice.getDetailError(param)
                if (resError.success) {
                    this.listError = resError.data
                } else {
                    this.$message({
                        message: resError,
                        type: 'error'
                    })
                }
            } catch (error) {
                this.$message({
                    message: error,
                    type: 'error'
                })
            }
            this.$loading().close()
        },
        countInvoiceDetail (data) {
            let total = {
                codCount: 0,
                codCountExcel: 0,
                codCusPay: 0,
                codDb: 0,
                codExcel: 0,
                codInvTotal: 0,
                codVat: 0,
                codWht: 0,
                delCount: 0,
                delCountExcel: 0,
                delCusPay: 0,
                delDb: 0,
                delExcel: 0,
                delInvTotal: 0,
                delWht: 0,
                discountPrice: 0,
                codExclVat: 0,
                codExclVatExcel: 0
            }
            data.forEach(s => {
                total.codCount += s.codCount
                total.codCountExcel += s.codCountExcel
                total.codCusPay += s.codCusPay
                total.codDb += s.codDb
                total.codExcel += s.codExcel
                total.codInvTotal += s.codInvTotal
                total.codVat += s.codVat
                total.codWht += s.codWht
                total.delCount += s.delCount
                total.delCountExcel += s.delCountExcel
                total.delCusPay += s.delCusPay
                total.delDb += s.delDb
                total.delExcel += s.delExcel
                total.delInvTotal += s.delInvTotal
                total.delWht += s.delWht
                total.discountPrice += s.discountPrice
                total.codExclVat += s.codExclVat
                total.codExclVatExcel += s.codExclVatExcel
            })
            return total
        },
        invoiceMan (arrInvoice) {
            let invoiceDetail = {}
            let total = {
                codCount: 0,
                codCountExcel: 0,
                codCusPay: 0,
                codDb: 0,
                codExcel: 0,
                codInvTotal: 0,
                codVat: 0,
                codWht: 0,
                delCount: 0,
                delCountExcel: 0,
                delCusPay: 0,
                delDb: 0,
                delExcel: 0,
                delInvTotal: 0,
                delWht: 0,
                discountPrice: 0,
                codExclVat: 0,
                codExclVatExcel: 0
            }
            arrInvoice.forEach(e => {
                if (invoiceDetail.hasOwnProperty(e.userCode)) {
                    if (invoiceDetail[e.userCode].hasOwnProperty(e.shopCode)) {
                        let sumCount = this.countInvoiceDetail(e.invoiceDetail)
                        invoiceDetail[e.userCode][e.shopCode] = {
                            ...e,
                            ...sumCount
                        }
                    } else {
                        let sumCount = this.countInvoiceDetail(e.invoiceDetail)
                        invoiceDetail[e.userCode][e.shopCode] = {
                            ...e,
                            ...sumCount
                        }
                    }
                } else {
                    let sumCount = this.countInvoiceDetail(e.invoiceDetail)
                    invoiceDetail[e.userCode] = {}
                    invoiceDetail[e.userCode][e.shopCode] = {}
                    invoiceDetail[e.userCode][e.shopCode] = {
                        ...e,
                        ...sumCount
                    }
                }
            })
            Object.values(invoiceDetail).forEach(e =>
                Object.values(e).forEach(s => {
                    total.codCount += s.codCount
                    total.codCountExcel += s.codCountExcel
                    total.codCusPay += s.codCusPay
                    total.codDb += s.codDb
                    total.codExcel += s.codExcel
                    total.codInvTotal += s.codInvTotal
                    total.codVat += s.codVat
                    total.codWht += s.codWht
                    total.delCount += s.delCount
                    total.delCountExcel += s.delCountExcel
                    total.delCusPay += s.delCusPay
                    total.delDb += s.delDb
                    total.delExcel += s.delExcel
                    total.delInvTotal += s.delInvTotal
                    total.delWht += s.delWht
                    total.discountPrice += s.discountPrice
                    total.codExclVat += s.codExclVat
                    total.codExclVatExcel += s.codExclVatExcel
                })
            )
            this.invoiceDetail = invoiceDetail
            this.invoiceTotal = total
            let ShopIdsMap = []

            Object.values(this.invoiceDetail).forEach(e =>
                Object.values(e).forEach(s => {
                    ShopIdsMap.push(s.invoiceDetail)
                })
            )
            ShopIdsMap = ShopIdsMap.flat()
            let shopIds = ShopIdsMap.map(e => e.shopId)
            this.AllShopIds = [...new Set(shopIds)]
        },
        async fetchInvoiceDetail () {
            try {
                let resInvoice = await fgApi.invoice.getInvoiceById(
                    parseInt(this.$route.query.invoiceId)
                )
                await this.invoiceMan(resInvoice.data)
                if (resInvoice.success) {
                    this.InvoiceRes = resInvoice.data
                    this.invoiceForm = { ...resInvoice.invoice }
                    if (this.invoiceForm.name && this.invoiceForm.note) {
                        this.showExport = true
                    }
                }
            } catch (error) {
                this.$message({
                    message: error,
                    type: 'error'
                })
            }
        },
        async updateInvoice () {
            this.$refs['invoiceForm'].validate(async valid => {
                if (valid) {
                    let param = {
                        invoice_id: parseInt(this.$route.query.invoiceId),
                        name: this.invoiceForm.name,
                        invoice_date: this.invoiceForm.invoiceDate,
                        note: this.invoiceForm.note
                    }
                    try {
                        let resInvoice = await fgApi.invoice.updateInvoice(
                            param
                        )
                        if (resInvoice.success) {
                            this.$message({
                                message: 'บันทึกข้อมูลเรียบร้อย!',
                                type: 'success'
                            })
                            // this.checkSumPayment = false
                            this.fetchInvoiceDetail()
                            this.fetchDetailError()
                        } else {
                            this.$message({
                                message: 'Oops, Api is error.',
                                type: 'error'
                            })
                        }
                    } catch (error) {
                        this.$message({
                            message: error,
                            type: 'error'
                        })
                    }
                }
            })
        },
        totalUserCode (obj) {
            let total = {
                codCount: 0,
                codCountExcel: 0,
                codCusPay: 0,
                codDb: 0,
                codExcel: 0,
                codInvTotal: 0,
                codVat: 0,
                codWht: 0,
                delCount: 0,
                delCountExcel: 0,
                delCusPay: 0,
                delDb: 0,
                delExcel: 0,
                delInvTotal: 0,
                delWht: 0,
                codExclVat: 0,
                codExclVatExcel: 0
            }
            Object.values(obj).forEach(s => {
                total.codCount += s.codCount
                total.codCountExcel += s.codCountExcel
                total.codCusPay += s.codCusPay
                total.codDb += s.codDb
                total.codExcel += s.codExcel
                total.codInvTotal += s.codInvTotal
                total.codVat += s.codVat
                total.codWht += s.codWht
                total.delCount += s.delCount
                total.delCountExcel += s.delCountExcel
                total.delCusPay += s.delCusPay
                total.delDb += s.delDb
                total.delExcel += s.delExcel
                total.delInvTotal += s.delInvTotal
                total.delWht += s.delWht
                total.codExclVat += s.codExclVat
                total.codExclVatExcel += s.codExclVatExcel
            })
            // return obj
            return total
        },
        getNameCustomer (obj) {
            let data = {
                fname: '',
                lname: ''
            }
            Object.values(obj).forEach(s => {
                data.fname = s.firstName
                data.lname = s.lastName
            })
            return data
        },
        showOrderList (val) {
            let shopIds = val.map(e => e.shopId)
            var uniqShopIds = [...new Set(shopIds)]
            this.orderlist.shopId = uniqShopIds
            this.orderlist.dialogShow = !this.orderlist.dialogShow
        },
        async exportExcel (shopID, runningNumber, shopCode) {
            this.$loading()
            let shopIds = shopID.map(e => e.shopId)
            var uniqShopIds = [...new Set(shopIds)]
            let param = {
                shop_ids: uniqShopIds,
                invoice_id: parseInt(this.$route.query.invoiceId)
            }
            try {
                let mergeTitle = [
                    // { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
                    // { s: { r: 1, c: 0 }, e: { r: 1, c: 5 } },
                    // { s: { r: 3, c: 1 }, e: { r: 6, c: 3 } }
                ]
                let wscols = [
                    { wch: 10 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 15 },
                    { wch: 15 }
                ]
                let resOrderExport = await fgApi.invoice.getExportExcel(param)
                let excelRaw = this.processExcelNew(
                    resOrderExport.data,
                    shopID,
                    runningNumber,
                    shopCode
                )
                this.saveInvoiceExcel(
                    excelRaw,
                    `-${shopCode}-INV${runningNumber}`,
                    wscols,
                    mergeTitle
                )
            } catch (e) {
                console.log(e)
                this.$message({
                    message: e,
                    type: 'error'
                })
            }
            this.$loading().close()
        },
        processExcelNew (resOrder, shopID, runningNumber, shopCode) {
            let dataSave = []
            if (typeof resOrder === 'object') {
                resOrder = Object.keys(resOrder).map(key => resOrder[key])
            }
            resOrder.forEach(e => {
                let excelData = this.processExcel(
                    e,
                    shopID,
                    runningNumber,
                    shopCode
                )
                dataSave.push(excelData)
            })
            return dataSave
        },
        processExcel (resOrder, shopID, runningNumber, shopCode) {
            // let CustomerAddress = resCustomer.bankAccountAddress + ' ต.' + resCustomer.bankAccountSubDistrict +
            //  ' อ.' + resCustomer.bankAccountDistrict + ' จ.' + resCustomer.bankAccountProvince + ' ' + resCustomer.bankAccountZipcode

            let dataTitle = [
                ['FILLGOODS TECHNONLGY CO., LTD. ( HEAD OFFICE)'],
                ['No. 173, Asia Center Building, 15 and 16 Floor, Sathorn Rd, Thung Maha Mek, Sathon, Bangkok 10120'],
                ['TAX ID NO: 0105561094334'],
                ['E-mail support@fillgoods.co'],
                ['Finance Officer: 02-117-3147'],
                [],
                [],
                ['INVOICE DETAIL'],
                ['invoice Number :', 'INV' + runningNumber],
                ['Invoice Date :', this.invoiceForm.invoiceDate],
                ['Shop Code No:', shopCode]
            ]
            let DataTrans = []
            let a = []
            resOrder.shops.forEach(e => {
                DataTrans = []
                let total = {
                    codAmount: 0,
                    codNetPrice: 0,
                    codTotal: 0,
                    delNetPrice: 0,
                    delTotal: 0
                }
                e.orders.forEach((ele, index) => {
                    // Cust Ref
                    if (ele['customerReferenceId'].search('\\e') !== -1) {
                        ele['customerReferenceId'] = ele['customerReferenceId'].replace('\\e', '')
                    }

                    let pickupDate = ele['pickupDate'] ? this.$dayjs(ele['pickupDate']).format('YYYY/MM/DD') : ''

                    let discountPrice = parseFloat(ele['discountPrice'].toFixed(2))
                    if (ele['discountPrice']) { discountPrice = '-' + parseFloat(ele['discountPrice'].toFixed(2)) }

                    let delFee = ele['delNetPrice'] - ele['remoteAreaPrice']

                    let excelData = [
                        String(index + 1),
                        pickupDate,
                        // ele.deliveredDate,
                        ele['customerName'],
                        ele['province'],
                        ele['zipcode'],
                        this.getZone(ele['province']), // Zone
                        ele['customerReferenceId'],
                        ele['actualSize'],
                        'CM',
                        String(ele['actualWeight']),
                        'G',
                        String(ele['volWeight']),
                        'G',
                        'CM',
                        String(ele['width']),
                        'CM',
                        String(ele['height']),
                        'CM',
                        String(ele['grossWeight']),
                        ele['codAmount'],
                        parseFloat(ele['codNetPrice'].toFixed(2)),
                        parseFloat(ele['codTotal'].toFixed(2)),
                        parseFloat(ele['remoteAreaPrice'].toFixed(2)),
                        parseFloat(delFee),
                        parseFloat(ele['delNetPrice'].toFixed(2)),
                        Number.parseFloat(discountPrice),
                        parseFloat(ele['delTotal'].toFixed(2)),
                        'THB'
                    ]
                    total.codAmount += ele['codAmount']
                    total.codNetPrice += ele['codNetPrice']
                    total.codTotal += ele['codTotal']
                    total.delNetPrice += ele['delNetPrice']
                    total.delTotal += ele['delTotal']
                    DataTrans.push(excelData)
                })
                let dataTitleShop = [
                    [],
                    ['Shop Name', e.shopName],
                    ['Shop Id', String(e.shopId).padStart(8, '0')],
                    [
                        'No.',
                        'Pickup Date',
                        'Consignee Name',
                        'Province',
                        'Zipcode',
                        'Zone',
                        'Cust Ref. ID.',
                        'Actual Size',
                        'Unit',
                        'Actual Weight',
                        'Unit',
                        'Vol. Weight',
                        'Unit',
                        'Unit',
                        'Width',
                        'Unit',
                        'Height',
                        'Unit',
                        'Gross Weight',
                        'CoD Amount',
                        'cod_net_price',
                        'cod_total',
                        'remote',
                        'del_fee',
                        'del_net_price',
                        'discount',
                        'del_total',
                        'Currency'
                    ]
                ]
                // let dataTotal = ['Total', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', total.codAmount, total.codNetPrice, total.codTotal, total.delNetPrice, total.delTotal]
                DataTrans = dataTitleShop.concat(DataTrans)
                a = a.concat(DataTrans)
                // a.push(dataTotal)
            })

            let excelData = dataTitle.concat(a)
            let excel = {
                excelData: excelData,
                courierName: resOrder.courierName
            }
            // let fileName = `${shopCode}-FGPA${runningNumber}`
            return excel
        },
        async exportPDF (obj2, runningNumber, shopCode) {
            this.$loading()
            let shopIds = obj2.invoiceDetail.map(e => e.shopId)
            var uniqShopIds = [...new Set(shopIds)]
            let fileName = `-${shopCode}-INV${runningNumber}`
            let idCustomer =
                uniqShopIds[uniqShopIds.indexOf(parseInt(shopCode))]
            if (!idCustomer) {
                idCustomer = parseInt(shopCode)
            }
            let resShopDetail = await fgApi.shop.getShopByShopID({
                shop_id: idCustomer
            })
            // 1 นิติ
            // 0 ธรรมดา
            let CustomerAddress =
                resShopDetail.data.bankAccountAddress +
                ' ต.' +
                resShopDetail.data.bankAccountSubDistrict +
                ' อ.' +
                resShopDetail.data.bankAccountDistrict +
                ' จ.' +
                resShopDetail.data.bankAccountProvince +
                ' ' +
                resShopDetail.data.bankAccountZipcode
            let dateInvoiceEnd = this.$dayjs(this.invoiceForm.invoiceDate)
                .add(7, 'day')
                .format('YYYY/MM/DD')
            let paramPdf = {
                customerAddress: CustomerAddress,
                customerCode: shopCode,
                customerName: resShopDetail.data.bankAccountName,
                customerTaxNumber: resShopDetail.data.taxId,
                date: 'testDate',
                invoiceNumber: `INV${runningNumber}`,
                tableData: obj2,
                typeAccount: resShopDetail.data.bankAccountType,
                invoice: this.invoiceForm,
                dateEnd: dateInvoiceEnd,
                fileName: fileName
            }
            this.generatePDFInvoice(paramPdf)
                .catch(error => {
                    this.$message({
                        message: error,
                        type: 'error'
                    })
                })
            this.$loading().close()
        },
        showAlert (id) {
            let list = this.listError.filter(e => {
                if (e.shopId === id) {
                    return e
                }
            })
            if (list.length > 0) {
                return true
            } else {
                return false
            }
        },
        EditRunningNumber (runningNumber, detail, shopCode) {
            let shopIds = detail.map(e => e.shopId)
            var uniqShopIds = [...new Set(shopIds)]
            this.shopCodeRunningNumber = shopCode
            this.runningNumberEdit = runningNumber
            this.shopIdRunningNumberEdit = uniqShopIds
            this.dialogShowRunningNumber = !this.dialogShowRunningNumber
        },
        async exportExcelAll () {
            this.$loading()
            let param = {
                shop_ids: this.AllShopIds,
                invoice_id: parseInt(this.$route.query.invoiceId)
            }
            try {
                let mergeTitle = [
                    // { s: { r: 0, c: 0 }, e: { r: 0, c: 5 } },
                    // { s: { r: 1, c: 0 }, e: { r: 1, c: 5 } },
                    // { s: { r: 3, c: 1 }, e: { r: 6, c: 3 } }
                ]
                let wscols = [
                    // { wch: 10 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 15 }
                ]
                let resOrderExport = await fgApi.invoice.getExportExcel(param)
                let dataSave = []
                resOrderExport.data.forEach(e => {
                    let excelData = this.processExcelAll(e)
                    dataSave.push(excelData)
                })
                this.saveInvoiceExcel(
                    dataSave,
                    `invoiceAll`,
                    wscols,
                    mergeTitle
                )
            } catch (e) {
                console.log(e)
                this.$message({
                    message: e,
                    type: 'error'
                })
            }
            this.$loading().close()
        },
        processExcelAll (resOrder) {
            let dataTitle = [
                [
                    'No.',
                    'Shop Name',
                    'Shop Code',
                    'Pickup Date',
                    'Consignee Name',
                    'Province',
                    'Zipcode',
                    'Zone',
                    'Cust Ref. ID.',
                    'Actual Size',
                    'Unit',
                    'Actual Weight',
                    'Unit',
                    'Vol. Weight',
                    'Unit',
                    'Unit',
                    'Width',
                    'Unit',
                    'Height',
                    'Unit',
                    'Gross Weight',
                    'CoD Amount',
                    'cod_net_price',
                    'cod_total',
                    'remote',
                    'del_fee',
                    'del_net_price',
                    'discount',
                    'del_total',
                    'Currency'
                ]
            ]
            let DataTrans = []
            let a = []
            let count = 1
            resOrder.shops.forEach(e => {
                DataTrans = []

                e.orders.forEach((ele, index) => {
                    if (ele['customerReferenceId'].search('\\e') !== -1) {
                        ele['customerReferenceId'] = ele['customerReferenceId'].replace('\\e', '')
                    }

                    let pickupDate = ele['pickupDate'] ? this.$dayjs(ele['pickupDate']).format('YYYY/MM/DD') : ''

                    let discountPrice = parseFloat(ele['discountPrice'].toFixed(2))
                    if (ele['discountPrice']) { discountPrice = '-' + parseFloat(ele['discountPrice'].toFixed(2)) }

                    let delFee = ele['delNetPrice'] - ele['remoteAreaPrice']

                    let excelData = [
                        String(count),
                        e.shopName,
                        e.shopCode,
                        pickupDate,
                        // ele.deliveredDate,
                        ele['customerName'],
                        ele['province'],
                        ele['zipcode'],
                        this.getZone(ele['province']), // Zone
                        ele['customerReferenceId'],
                        ele['actualSize'],
                        'CM',
                        String(ele['actualWeight']),
                        'G',
                        String(ele['volWeight']),
                        'G',
                        'CM',
                        String(ele['width']),
                        'CM',
                        String(ele['height']),
                        'CM',
                        String(ele['grossWeight']),
                        ele['codAmount'],
                        parseFloat(ele['codNetPrice'].toFixed(2)),
                        parseFloat(ele['codTotal'].toFixed(2)),
                        parseFloat(ele['remoteAreaPrice'].toFixed(2)),
                        parseFloat(delFee),
                        parseFloat(ele['delNetPrice'].toFixed(2)),
                        discountPrice,
                        parseFloat(ele['delTotal'].toFixed(2)),
                        'THB'
                    ]
                    count++
                    DataTrans.push(excelData)
                })
                a = a.concat(DataTrans)
            })
            let excelData = dataTitle.concat(a)
            let excel = {
                excelData: excelData,
                courierName: resOrder.courierName
            }
            return excel
        },
        async zipAllInvoice () {
            let loading = {
                percent: 0
            }
            eventBus.$emit('showProgressBar', '')
            eventBus.$emit('updatePercent', loading)
            let filePdfPromise = []
            let fileExcel = []
            for (const [index, Invoice] of Object.values(
                this.InvoiceRes
            ).entries()) {
                loading.percent = ((index + 1) / this.InvoiceRes.length) * 100
                loading.percent = loading.percent.toFixed(2)
                eventBus.$emit('updatePercent', loading)
                let shopIds = Invoice.invoiceDetail.map(e => e.shopId)
                var uniqShopIds = [...new Set(shopIds)]
                // EXCEL
                let param = {
                    shop_ids: uniqShopIds,
                    invoice_id: parseInt(this.$route.query.invoiceId)
                }
                let resOrderExport = await fgApi.invoice.getExportExcel(param)
                let excelRaw = this.processExcelNew(
                    resOrderExport.data,
                    Invoice.shopID,
                    Invoice.runningNumber,
                    Invoice.shopCode
                )
                fileExcel.push(
                    this.getExcelFileInvoice(
                        excelRaw,
                        `-${Invoice.shopCode}-INV${Invoice.runningNumber}`
                    )
                )
                // PDF
                let idCustomer =
                    uniqShopIds[uniqShopIds.indexOf(parseInt(Invoice.shopCode))]
                if (!idCustomer) {
                    idCustomer = parseInt(Invoice.shopCode)
                }
                let resShopDetail = await fgApi.shop.getShopByShopID({
                    shop_id: idCustomer
                })
                let CustomerAddress =
                    resShopDetail.data.bankAccountAddress +
                    ' ต.' +
                    resShopDetail.data.bankAccountSubDistrict +
                    ' อ.' +
                    resShopDetail.data.bankAccountDistrict +
                    ' จ.' +
                    resShopDetail.data.bankAccountProvince +
                    ' ' +
                    resShopDetail.data.bankAccountZipcode
                let dateInvoiceEnd = this.$dayjs(this.invoiceForm.invoiceDate)
                    .add(7, 'day')
                    .format('YYYY/MM/DD')
                let obj2 = {}
                Object.values(this.invoiceDetail).forEach(e => {
                    if (e.hasOwnProperty(Invoice.shopCode)) {
                        obj2 = e[Invoice.shopCode]
                    }
                })
                let paramPdf = {
                    customerAddress: CustomerAddress,
                    customerCode: Invoice.shopCode,
                    customerName: resShopDetail.data.bankAccountName,
                    customerTaxNumber: resShopDetail.data.taxId,
                    date: 'testDate',
                    invoiceNumber: `INV${Invoice.runningNumber}`,
                    tableData: obj2,
                    typeAccount: resShopDetail.data.bankAccountType,
                    invoice: this.invoiceForm,
                    dateEnd: dateInvoiceEnd,
                    fileName: `-${Invoice.shopCode}-INV${Invoice.runningNumber}`
                }
                filePdfPromise.push(await this.getPDFInvoice(paramPdf))
            }
            Promise.all(filePdfPromise)
                .then(pdfFiles => {
                    let zipFile = jsZip()
                    try {
                        pdfFiles.forEach((pdf, idx) => {
                            zipFile.file(pdf[1], pdf[0])
                        })
                        fileExcel.forEach(excel => {
                            zipFile.file(excel[1], excel[0])
                        })

                        zipFile
                            .generateAsync(
                                { type: 'blob', streamFiles: true },
                                function updateCallback (metadata) {
                                    eventBus.$emit('updatePercent', {
                                        percent: metadata.percent.toFixed(2)
                                    })
                                }
                            )
                            .then(function (blob) {
                                saveAs(blob, 'Invoice_all.zip')
                                eventBus.$emit('hideProgressBar', '')
                            })
                            .catch(error => {
                                this.$notify.error({
                                    title: 'Error',
                                    message: error,
                                    duration: 0
                                })
                                eventBus.$emit('hideProgressBar', '')
                                console.log(error)
                            })
                    } catch (error) {
                        this.$notify.error({
                            title: 'Error',
                            message: error,
                            duration: 0
                        })
                        eventBus.$emit('hideProgressBar', '')
                        console.log(error)
                    }
                })
                .catch(() => {})
        },
        async zipAllInvoiceNew () {
            let loading = {
                percent: 0
            }
            eventBus.$emit('showProgressBar', '')
            eventBus.$emit('updatePercent', loading)
            let filePdfPromise = []
            let fileExcel = []
            let params = []
            let shopIDSS = []
            let unqiShopIDSS = []
            let Invoices = []
            // eslint-disable-next-line no-unused-vars
            for (const [index, Invoice] of Object.values(
                this.InvoiceRes
            ).entries()) {
                let shopIds = Invoice.invoiceDetail.map(e => e.shopId)
                var uniqShopIds = [...new Set(shopIds)]
                Invoices.push(Invoice)
                shopIDSS.push(shopIds)
                unqiShopIDSS.push(uniqShopIds)
                params.push({
                    shop_ids: uniqShopIds,
                    invoice_id: parseInt(this.$route.query.invoiceId)
                })
            }

            let resOrderExports = await fgApi.invoice.getExportsExcel({
                data: params
            })

            // Convert binary string to character-number array
            var charData = atob(resOrderExports.data)
                .split('')
                .map(function (x) {
                    return x.charCodeAt(0)
                })

            // Turn number array into byte-array
            var binData = new Uint8Array(charData)

            var result = pako.inflate(binData, {
                to: 'string'
            })

            const decompressed = JSON.parse(result)

            const processVal = val =>
                typeof val !== 'object' || val === null
                    ? val
                    : Array.isArray(val)
                        ? val.map(renameKeys)
                        : renameKeys(val)
            const renameKeys = obj =>
                Object.fromEntries(
                    Object.entries(obj).map(([key, val]) => [
                        key.replace(/_(.)/g, g => g[1].toUpperCase()),
                        processVal(val)
                    ])
                )

            let paramPdfs = []
            for (let i = 0; i < shopIDSS.length; i++) {
                loading.percent = ((i + 1) / this.InvoiceRes.length) * 100
                loading.percent = loading.percent.toFixed(2)
                eventBus.$emit('updatePercent', loading)
                let excelRaw = this.processExcelNew(
                    renameKeys(decompressed[i]),
                    Invoices[i].shopID,
                    Invoices[i].runningNumber,
                    Invoices[i].shopCode
                )

                fileExcel.push(
                    this.getExcelFileInvoice(
                        excelRaw,
                        `-${Invoices[i].shopCode}-INV${Invoices[i].runningNumber}`
                    )
                )
                // PDF
                let idCustomer =
                    unqiShopIDSS[i][unqiShopIDSS[i].indexOf(parseInt(Invoices[i].shopCode))]
                if (!idCustomer) {
                    idCustomer = parseInt(Invoices[i].shopCode)
                }
                let resShopDetail = await fgApi.shop.getShopByShopID({
                    shop_id: idCustomer
                })
                let CustomerAddress =
                    resShopDetail.data.bankAccountAddress +
                    ' ต.' +
                    resShopDetail.data.bankAccountSubDistrict +
                    ' อ.' +
                    resShopDetail.data.bankAccountDistrict +
                    ' จ.' +
                    resShopDetail.data.bankAccountProvince +
                    ' ' +
                    resShopDetail.data.bankAccountZipcode
                let dateInvoiceEnd = this.$dayjs(this.invoiceForm.invoiceDate)
                    .add(7, 'day')
                    .format('YYYY/MM/DD')
                let obj2 = {}
                Object.values(this.invoiceDetail).forEach(e => {
                    if (e.hasOwnProperty(Invoices[i].shopCode)) {
                        obj2 = e[Invoices[i].shopCode]
                    }
                })
                let paramPdf = {
                    customerAddress: CustomerAddress,
                    customerCode: Invoices[i].shopCode,
                    customerName: resShopDetail.data.bankAccountName,
                    customerTaxNumber: resShopDetail.data.taxId,
                    date: 'testDate',
                    invoiceNumber: `INV${Invoices[i].runningNumber}`,
                    tableData: obj2,
                    typeAccount: resShopDetail.data.bankAccountType,
                    invoice: this.invoiceForm,
                    dateEnd: dateInvoiceEnd,
                    fileName: `-${Invoices[i].shopCode}-INV${Invoices[i].runningNumber}`
                }
                paramPdfs.push(paramPdf)
            }

            const txID = uuidv4()

            const delayTime = paramPdfs.length < 10 ? 3000 : 5000
            let blobs = []
            function sleep (ms) {
                return new Promise(resolve => setTimeout(resolve, ms))
            }

            let percentage = 95.0

            while (true) {
                await sleep(delayTime)
                const result = await this.getPDFInvoices(paramPdfs, txID)
                // not finish
                if (result === false) {
                    if (percentage === 95.0) {
                        percentage = 80.0
                    } else {
                        percentage = 95 / 100
                    }
                    eventBus.$emit('updatePercent', percentage)
                    console.log('STILL PROGRESS PLEASE WATING')
                    continue
                }

                blobs = result
                eventBus.$emit('updatePercent', 100.0)

                break
            }

            paramPdfs.forEach((p, i) => {
                filePdfPromise.push([blobs[i], p.fileName + '.pdf'])
            })
            Promise.all(filePdfPromise)
                .then(pdfFiles => {
                    let zipFile = jsZip()
                    try {
                        pdfFiles.forEach((pdf, idx) => {
                            zipFile.file(pdf[1], pdf[0])
                        })
                        fileExcel.forEach(excel => {
                            zipFile.file(excel[1], excel[0])
                        })

                        zipFile
                            .generateAsync(
                                { type: 'blob', streamFiles: true },
                                function updateCallback (metadata) {
                                    eventBus.$emit('updatePercent', {
                                        percent: metadata.percent.toFixed(2)
                                    })
                                }
                            )
                            .then(function (blob) {
                                saveAs(blob, 'Invoice_all.zip')
                                eventBus.$emit('hideProgressBar', '')
                            })
                            .catch(error => {
                                this.$notify.error({
                                    title: 'Error',
                                    message: error,
                                    duration: 0
                                })
                                eventBus.$emit('hideProgressBar', '')
                                console.log(error)
                            })
                    } catch (error) {
                        this.$notify.error({
                            title: 'Error',
                            message: error,
                            duration: 0
                        })
                        eventBus.$emit('hideProgressBar', '')
                        console.log(error)
                    }
                })
                .catch(() => {})
        },
        exportSummary () {
            this.$loading()
            let headerExcel = [
                [
                    'Shop Id',
                    'Shop Code',
                    'Shop Name',
                    'ชื่อ',
                    'User Code',
                    'Invice Number',
                    'Count of Order Excel',
                    'Count of Order DB',
                    'Sum of DEL Excel',
                    'Sum of DEL DB',
                    'WHT 1% (Excel)',
                    'Inv.Total (Excel)',
                    'Customer Pay (Excel)',
                    'Count of Order Excel',
                    'Count of Order DB',
                    'Sum of COD Excel',
                    'Sum of COD DB',
                    'COD Bef. VAT Excel',
                    'COD Bef. VAT DB',
                    'VAT 7% (Excel)',
                    'WHT 3% (Excel)',
                    'Inv.Total (Excel)',
                    'Customer Pay (Excel)',
                    'Courier Excel',
                    'Courier DB',
                    'Tax Id'
                ]
            ]
            Object.values(this.invoiceDetail).forEach(e => {
                Object.values(e).forEach(s => {
                    s.invoiceDetail.forEach(d => {
                        let data = [
                            d.shopId,
                            s.shopCode,
                            d.shopName,
                            s.firstName + ' ' + s.lastName,
                            s.userCode,
                            'INV' + s.runningNumber,
                            d.delCountExcel,
                            d.delCount,
                            d.delExcel.toFixed(2),
                            d.delDb.toFixed(2),
                            d.delWht.toFixed(2),
                            d.delInvTotal.toFixed(2),
                            d.delCusPay.toFixed(2),
                            d.codCountExcel,
                            d.codCount,
                            d.codExcel.toFixed(2),
                            d.codDb.toFixed(2),
                            d.codExclVatExcel.toFixed(2),
                            d.codExclVat.toFixed(2),
                            d.codVat.toFixed(2),
                            d.codWht.toFixed(2),
                            d.codInvTotal.toFixed(2),
                            d.codCusPay.toFixed(2),
                            d.courierNameExcel,
                            d.courierName,
                            d.shopTaxId
                        ]
                        headerExcel.push(data)
                    })
                })
            })
            this.saveExcel(headerExcel, 'Summary')
            this.$loading().close()
        },
        confirmInvoice () {
            this.$confirm('Are you sure to confirm this Invoice ?', 'Warning', {
                confirmButtonText: 'OK',
                cancelButtonText: 'Cancel',
                type: 'warning'
            })
                .then(async () => {
                    if (this.showExport) {
                        this.$loading()
                        let param = {
                            invoice_id: parseInt(this.$route.query.invoiceId),
                            email: this.$store.get('user/objUser').email
                        }
                        try {
                            let res = await fgApi.invoice.confirmInvoice(param)
                            if (res.success) {
                                this.vuexFcnctionExport(
                                    parseInt(this.$route.query.invoiceId)
                                )
                                this.$message({
                                    message: 'อัพเดทข้อมูลสำเร็จ',
                                    type: 'success'
                                })
                                this.invoiceForm.status = 1
                            }
                        } catch (error) {
                            this.$message.error(error)
                        }
                        this.$loading().close()
                    } else {
                        this.$message({
                            message: 'กรุณาบันทึกรายการ',
                            type: 'warning'
                        })
                    }
                })
                .catch(() => {
                    console.log('Cancel')
                })
        }
    }
}
</script>

<style lang="scss">
.tbPaymentDetail {
    font-size: 8px !important;
    border-collapse: collapse;
    width: 100%;
    th {
        padding-top: 12px;
        padding-bottom: 12px;
        text-align: left;
        background-color: teal;
        color: white;
    }
    td,
    th {
        border: 1px solid #ddd;
        padding: 8px;
    }
    tr:hover {
        background-color: #ddd;
    }
    .fas {
        cursor: pointer;
    }
    .el-button--mini {
        padding: 4px 8px;
        font-size: 9px;
        border-radius: 3px;
    }
}
</style>
